import { FormGroup, FormControl } from '@angular/forms';
import { OAuthService,AuthConfig } from 'angular-oauth2-oidc';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { OktaAuthService ,OktaLoginRedirectComponent} from '@okta/okta-angular';


// export const authConfig :AuthConfig ={
//   // issuer: 'https://dev-97790115.okta.com/oauth2/default/',
//   // //redirectUri : window.location.origin,
//   // redirectUri: 'http://localhost:4200/',
//   // clientId :  '0oa1e1xdaug0vFKBF5d7'
//   issuer: 'https://myappstest.halliburton.com/oauth2/ausk4axfvsdNLJ8rU0h7',
//   redirectUri: 'http://localhost:4200',
//   clientId: '0oa10q953d9w4Hx0E0h8',
//   scope: 'openid profile email' 
// } 

// const config = {
//   issuer: 'https://myappstest.halliburton.com/oauth2/ausk4axfvsdNLJ8rU0h7',
//   redirectUri: 'http://localhost:4200/implicit/callback',
//   clientId: '0oaz1of05jBjlFoCo0h7',
//   scope: 'openid profile email'
// };

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
// export class AppComponent implements OnInit {
//   ngOnInit(): void {
//     throw new Error('Method not implemented.');
//   }
export class AppComponent {
  title = 'app';
  isAuthenticated: boolean;
  baseUri: string;
  originalUri: '/';

  

  // constructor(public oktaAuth: OktaAuthService) {
  //   this.oktaAuth.$authenticationState.subscribe(isAuthenticated => this.isAuthenticated = isAuthenticated);
  // }


  columnDefs = [
    {headerName: 'Invoice Numer', field: 'invoicenumber' ,sortable:"true", filter:"true",resizable: true,width:"160px" },
    {headerName: 'Amount', field: 'amount',sortable:"true", filter:"true",resizable: true,width:"160px" },
    {headerName: 'Currency', field: 'currency',sortable:"true", filter:"true",resizable: true,width:"160px" },
    {headerName: 'Payment reference', field: 'paymentreference',sortable:"true", filter:"true",resizable: true ,width:"160px"},
    {headerName: 'Scheduled Pay Date', field: 'scheduledpaydate',sortable:"true", filter:"true",resizable: true ,width:"160px"},
    {headerName: 'Actual Paid Date', field: 'actualpaiddate',sortable:"true", filter:"true",resizable: true ,width:"160px"},
    {headerName: 'Invoice Status', field: 'invoicestatus',sortable:"true", filter:"true",resizable: true ,width:"148.5x"}
];

rowData = [
  {invoicenumber:'207879',amount:'54145',currency:'USD',paymentreference:'6909063',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'},
  {invoicenumber:'207800',amount:'6466',currency:'USD',paymentreference:'756866',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'},
  {invoicenumber:'207895',amount:'86868686',currency:'USD',paymentreference:'773833',scheduledpaydate:'July 19, 2020',actualpaiddate:'july 20,2021',invoicestatus:'PAID'}
  
 ];

 //constructor(public oktaAuth: OktaAuthService) {

  // get authentication state for immediate use
  // this.oktaAuth.isAuthenticated().then(result => {
  //   this.isAuthenticated = result;
  // });

  // // subscribe to authentication state changes
  // this.oktaAuth.$authenticationState.subscribe(
  //   (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
  // );
  //}
//  constructor(private oauthService : OAuthService){
//    this.oauthService.configure(authConfig);
//    this.oauthService.loadDiscoveryDocumentAndTryLogin();
//  }

 
//  login(){
//   //this.oauthService.initImplicitFlow();
//   //this.oauthService.loadDiscoveryDocumentAndTryLogin()
//   this.oauthService.loadDiscoveryDocumentAndTryLogin().then(doc => {
//     this.oauthService.initImplicitFlow();
//   });
//   }
  
//   logout(){
//   this.oauthService.logOut();
//   }
//   get getUserNamer(){
//   const claims=this.oauthService.getIdentityClaims();
//   if(!claims){
//   return null;
// }
//   return claims['name'];
//   }

// async ngOnInit() {
//   this.isAuthenticated = await this.oktaAuth.isAuthenticated();
//          // Subscribe to authentication state changes
//   this.oktaAuth.$authenticationState.subscribe( async(isAuthenticated: boolean)  => {
//     this.isAuthenticated = isAuthenticated;
//             });}

// ngOnInit() {

  
  
//  // get authentication state for immediate use
//  this.oktaAuth.isAuthenticated().then(result => {
//   this.isAuthenticated = result;
// });

// // subscribe to authentication state changes
// this.oktaAuth.$authenticationState.subscribe(
//   (isAuthenticated: boolean) => this.isAuthenticated = isAuthenticated
// );
// }

// async login() {
//   //await this.oktaAuth.signInWithRedirect({ originalUri: '/' }); 
//   await this.oktaAuth.loginRedirect(this.originalUri);
// }

// async logout() {
//   //await this.oktaAuth.signOut();
//   await this.oktaAuth.logout();
// }

}
